module.exports = __webpack_public_path__ + "media/assets/images/quotation_detail1-e57bdd3bb2465c611012d05096005be2.png";